import React, { useState } from "react";
import { TagInput } from "rsuite";
import { Uploader } from "rsuite";
import { Button, Upload } from "antd";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import { MultiSelect } from "primereact/multiselect";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const specializations = [
  { name: "General Physician", code: "GP" },
  { name: "Cardiologist", code: "CARD" },
  { name: "Dermatologist", code: "DERM" },
  { name: "Neurologist", code: "NEUR" },
  { name: "Orthopedic Surgeon", code: "ORTHO" },
  { name: "Pediatrician", code: "PED" },
  { name: "Psychiatrist", code: "PSY" },
  { name: "Gynecologist", code: "GYN" },
  { name: "Oncologist", code: "ONC" },
  { name: "ENT Specialist", code: "ENT" },
  { name: "Ophthalmologist", code: "OPH" },
  { name: "Dentist", code: "DENT" },
  { name: "Radiologist", code: "RAD" },
  { name: "Anesthesiologist", code: "ANES" },
  { name: "Gastroenterologist", code: "GAST" },
  { name: "Nephrologist", code: "NEPH" },
  { name: "Urologist", code: "URO" },
  { name: "Endocrinologist", code: "ENDO" },
  { name: "Pulmonologist", code: "PULM" },
  { name: "Rheumatologist", code: "RHEU" },
  { name: "Hematologist", code: "HEMA" },
  { name: "Plastic Surgeon", code: "PLAST" },
  { name: "General Surgeon", code: "SURG" },
  { name: "Neurosurgeon", code: "NEUS" },
  { name: "Cosmetologist", code: "COSM" },
  { name: "Pathologist", code: "PATH" },
  { name: "Sexologist", code: "SEXO" },
  { name: "Allergist/Immunologist", code: "ALLG" },
  { name: "Diabetologist", code: "DIAB" },
  { name: "Laparoscopic Surgeon", code: "LAP" },
  { name: "Internal Medicine Specialist", code: "IMED" },
  { name: "Homeopathic Doctor", code: "HOME" },
  { name: "Ayurvedic Doctor", code: "AYUR" },
  { name: "Unani Practitioner", code: "UNANI" },
  { name: "Occupational Therapist", code: "OT" },
  { name: "Physiotherapist", code: "PHYSIO" },
];

function getStyles(name, personName, theme) {
  return {
    fontWeight: personName.includes(name)
      ? theme.typography.fontWeightMedium
      : theme.typography.fontWeightRegular,
  };
}

function StaffProffessionalInfo({ formik,isEditMode }) {
  const [selectedSpecializations, setSelectedSpecializations] = useState("");
  const multiselectstyles = `
  .css-yi3mkw {
      height: auto;
    min-height: 1.4375em;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    flex-wrap: nowrap;
  }
    /* Custom style for 24px height */
.multiselect-24px .p-multiselect {
  height: 24px !important;
  padding: 2px 6px;
  font-size: 0.75rem;
  line-height: 1;
}

.multiselect-24px .p-multiselect-label {
  padding: 3px 6px;
  font-size: 1rem;
  line-height: 1;
  display: flex;
  align-items: center;
}

.multiselect-24px .p-multiselect-token {
  padding: 1px 4px;
  font-size: 0.7rem;
  margin: 1px 2px;
  
}
  .p-multiselect-panel .p-checkbox-box {
  border: 2px solid #213343 !important;  /* Dark border */
  border-radius: 4px;
  width: 16px;
  height: 16px;
}

/* Optional: dark background on check */
.p-multiselect-panel .p-checkbox-box.p-highlight {
  background: #213343;
  border-color: #213343;
}

/* Checkmark color (tick inside) */
.p-multiselect-panel .p-checkbox-icon {
  color: white;
  font-size: 12px;
}
  `;

  const theme = useTheme();

  return (
    <>
      <style>{multiselectstyles}</style>
      <div className="row">
        <div className="col-12 d-flex flex-column align-items-start">
          <div className="col-12 d-flex">
            <h5
              className="fw-semibold h5-WOeTzEASAL"
              style={{ color: "rgb(43, 81, 147)", marginTop: "1rem" }}
            >
              Professional Details
            </h5>
          </div>
        </div>

        <div className="col-md-3 col-12">
          <div className="input-block mb-3">
            <label className="col-form-label lbl-VLJQLgvYMk">
              Profession<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Profession"
              value={formik.values.profession}
              name="medicallicensenumber"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </div>
        </div>

        <div className="col-md-3 col-12">
          <div className="input-block mb-3">
            <label className="col-form-label lbl-VLJQLgvYMk">
              Specialization<span className="text-danger">*</span>
            </label>
            <MultiSelect
              name="specialization"
              value={formik.values.specialization}
              onChange={(e) => formik.setFieldValue("specialization", e.value)}
              onBlur={formik.handleBlur}
              options={specializations}
              optionLabel="name"
              optionValue="name"
              placeholder="Select Specializations"
              maxSelectedLabels={3}
              showSelectAll={false}
              disabled={isEditMode}
              className="w-full md:w-20rem multiselect-24px border p-2"
            />
          </div>
        </div>

        <div className="col-md-3 col-12">
          <div className="input-block mb-3">
            <label className="col-form-label lbl-VLJQLgvYMk">
              Experience<span className="text-danger">*</span>
            </label>
            <input
              type="number"
              className="form-control"
              placeholder="Enter Your Experience"
              value={formik.values.yearsofexperience}
              name="yearsofexperience"
              min="0"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </div>
        </div>

        <div className="col-md-3 col-12">
          <div className="input-block mb-3">
            <label className="col-form-label lbl-VLJQLgvYMk">
              Medical License Number<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter License Number"
              value={formik.values.medicallicensenumber}
              name="medicallicensenumber"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </div>
        </div>

        <div className="mb-3">
            <div className="d-flex align-items-center w-50 gap-2 div-kasxoakxm">
              <label className="col-form-label abt-pr">
               Profession Bio<span className="text-danger">*</span>
              </label>
            </div>
            <textarea
              className="form-control"
              placeholder="Enter Professional Biography and experience"
              style={{
                color: "rgb(66, 66, 66)",
                height: "110px",
                letterSpacing: "0.5px",
                fontSize: "0.9rem",
                padding: "0.8rem",
                lineHeight: "1.7",
              }}
              name="Professionbio"
              value={formik.values.bio}
              onChange={(e) => formik.setFieldValue("Professionbio", e.target.value)}
            ></textarea>
          </div>

      </div>
    </>
  );
}

export default StaffProffessionalInfo;
